module.exports = __webpack_public_path__ + "deb3da65733a2f142db99637ac9fdf32.pdf";